import { useEffect } from 'react';
import { SectionHeading } from '@/components/home/SectionHeading';
import GuaranteeBadge from './GuaranteeBadge';
import { HOME } from '@/constants/testIds';

const STEPS = [
  { title: 'WhatsApp lokasi anda', desc: 'Hantar lokasi dan jenis rumah. Kami susun slot site visit yang sesuai.' },
  { title: 'Site visit percuma', desc: 'Semak sudut kamera dan laluan kabel. Percuma untuk lokasi dalam Lembah Klang.' },
  { title: 'Semak quotation', desc: 'Setuju model, skop dan harga dahulu. Kemudian bayar deposit 50%.' },
  { title: 'Test & handover', desc: 'Kamera diuji, app disetup bersama anda. Baki 50% selepas handover siap.' },
];

export const Process = () => {
  useEffect(() => {
    const el = document.createElement('script');
    el.id = 'howto-schema-jsonld';
    el.type = 'application/ld+json';
    el.textContent = JSON.stringify({ '@context': 'https://schema.org', '@type': 'HowTo', name: 'Cara booking pemasangan CCTV Goguard', step: STEPS.map((step, i) => ({ '@type': 'HowToStep', position: i + 1, name: step.title, text: step.desc })) });
    document.getElementById(el.id)?.remove();
    document.head.appendChild(el);
    return () => el.remove();
  }, []);
  return <section id="proses" data-testid={HOME.processSection} className="gg-section"><div className="gg-container"><SectionHeading id="process" eyebrow="4 LANGKAH, SATU TEAM" title="Dari WhatsApp sampai CCTV siap digunakan.">Anda tahu apa yang dipasang, berapa harganya dan bila perlu bayar.</SectionHeading><div className="gg-process-grid">{STEPS.map((step, i) => <div key={step.title} className="gg-step" data-testid={`process-step-${i}`}><span className="gg-step-number">0{i + 1}</span><h3>{step.title}</h3><p>{step.desc}</p></div>)}</div><GuaranteeBadge /></div></section>;
};

export default Process;